import { react2angular } from 'react2angular';
import angular from 'angular';

import VirtualTourDetails from './VirtualTourDetails';

angular
  .module('bb.external.virtual_tour_details', ['bb.users'])
  .component(
    'bbVirtualTourDetailsExternal',
    react2angular(
      VirtualTourDetails,
      [],
      ['ExternalAuth', '$routeParams', '$location', '$rootScope'],
    ),
  )
  .component(
    'bbVirtualTourDetails',
    react2angular(
      VirtualTourDetails,
      ['isMyBusiness'],
      ['$routeParams', '$location', '$rootScope'],
    ),
  );
